import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { orderBy, filter as lodashFilter, countBy } from 'lodash-es';
import { UserService } from '../../../../core/services/user.service';
import { ModalNavigationEnum } from '../../../constants';
import { DUPLICATE_FIELD_ERROR } from 'src/app/modals/integration-settings/shared/constants';

@Component({
    selector: 'app-technology-map-fields-form',
    templateUrl: './technology-map-fields-form.component.html',
    styleUrls: ['./technology-map-fields-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TechnologyMapFieldsFormComponent implements OnInit {
    @Input() public exportMappings: Array<any>;
    @Input() public exportFields: Array<any>;
    @Input() public form: FormGroup;
    @Input() public mappingType: string;
    @Input() disableForm: any;
    @Input() public exportType: string;
    @Input() technoExportMappingSetting = [];
    @Input() lastVisitedDateMappedFields: string[] = [];

    isSalsIntelAdmin = true;
    leadSource: any;
    fieldArray;
    settingsModalConfig = {
        class: 'modal-xl',
        initialState: { }
    };
    exportFieldArray;

    readonly exportControlName = 'crmTechnology';
    readonly modalNavigationEnum: typeof ModalNavigationEnum = ModalNavigationEnum;
    readonly duplicateFieldError = DUPLICATE_FIELD_ERROR;

    constructor(
        private userService: UserService,
    ) {
    }

    ngOnInit(): void {
        this.exportFieldArray = orderBy(this.exportFields, ['label'], ['asc']);
        this.leadSource = lodashFilter(this.exportFieldArray, item => item['field'] === 'LeadSource');
        if (this.disableForm) {
            this.form.disable();
        }
        if (!this.disableForm && !this.userService.isAdmin()) {
            this.isSalsIntelAdmin = false;
        }
    }

    isValid(selectedSalesintelField) {
        const countFields = countBy(this.form.value[this.mappingType].filter(x => x[this.exportControlName] !== ''), this.exportControlName);
        this.form.value[this.mappingType].forEach((element, index) => {
            if (element.salesintelTechnology === selectedSalesintelField && element.isBug) {
                element.isBug = false;
                this.form.controls[this.mappingType]['controls'][index].setValue(element);
            }

            element.isError = (countFields[element[this.exportControlName]] > 1) ||
                (this.lastVisitedDateMappedFields?.includes(element[this.exportControlName]));
        });
    }
}
